import Vue from 'vue';
import Element from 'element-ui';
import Brick from '@med/brick';

const userArray = [Element, Brick];
userArray.map(component => Vue.use(component));
